// src/store/app/slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store/store';

export interface AppState {
  isAndroidNativeApp: boolean;
}

const initialState: AppState = {
  isAndroidNativeApp: false,
};

const nativeSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setNativeApp(state, action: PayloadAction<boolean>) {
      state.isAndroidNativeApp = action.payload;
    },
  },
});

export const { setNativeApp } = nativeSlice.actions;
export const selectIsAndroidNativeApp = (state: RootState) =>
  state.native.isAndroidNativeApp;
export default nativeSlice.reducer;
